import { v4 as uuidv4 } from 'uuid';
import { SampleItem, App, Image, ImageContent } from '@types';
import { defaultEmptyImage } from '@components/globalContext';
import { Image as ImageUtils } from '@utils';
const localStorageNamespace = 'wiremesh';
const IMAGE_META_STORAGE_KEYS = ['src', 'previewSrc', 'mod', 'previewMod', 'filename'];

const LocalStorage = {
  getOrGenerateClientId: () => {
    const key = `${localStorageNamespace}.clientId`;
    const existing = localStorage.getItem(key);
    if (existing !== null) {
      return existing;
    }
    const id = uuidv4();
    localStorage.setItem(key, id);
    return id;
  },

  updateImage: (imageMeta: ImageContent) => {
    IMAGE_META_STORAGE_KEYS.forEach((key) => {
      if (imageMeta[key] !== undefined) {
        localStorage.setItem(`${localStorageNamespace}.${key}`, imageMeta[key]);
      }
    });
  },

  updateSamples: (items: SampleItem[]) => {
    localStorage.setItem(`${localStorageNamespace}.samples`, JSON.stringify(items));
  },

  getSamples: () => {
    const samples = localStorage.getItem(`${localStorageNamespace}.samples`);
    if (!samples) {
      return [];
    }
    return JSON.parse(samples);
  },

  clearImage: () => {
    const keys = ['src', 'previewSrc', 'mod', 'previewMod', 'filename'];
    keys.forEach((key) => {
      localStorage.setItem(`${localStorageNamespace}.${key}`, '');
    });
  },

  getImage: (): Image => {
    const image: Partial<ImageContent> = {};
    IMAGE_META_STORAGE_KEYS.forEach((key) => {
      image[key] = localStorage.getItem(`${localStorageNamespace}.${key}`);
    });
    if (!ImageUtils.exists({ imageContent: image as ImageContent })) {
      return defaultEmptyImage;
    }
    return {
      imageContent: image as ImageContent,
      ...defaultEmptyImage,
    };
  },

  updateLayout: (displayType: App['layout']) => {
    localStorage.setItem(`${localStorageNamespace}.layout`, displayType);
  },

  getLayout: () => {
    return localStorage.getItem(`${localStorageNamespace}.layout`);
  },
};

export default LocalStorage;
